export const HOME_PAGE_LINK = '/jobs';

export const POSTAD_PAGE_LINK = '/jobs/post-ad-jobs';

export const UPGRADE_AD_PAGE_LINK = '/jobs/upgrade-ad-jobs';

export const RECRUITMENT_ASSIST_LINK = '/jobs/vip-landing';

export const GUARANTEEDJOBS_LINK = '/jobs/guaranteed-job';

export const HIRE_LANDING_PAGE_LINK = '/jobs/hire';

export const CANDIATE_TEST_PAGE_LINK = '/jobs/candidate-test';



// WEBPACK FOOTER //
// ../q-jobs/src/constants/pageLinks.js